/* eslint camelcase: 0 */

import axios from 'axios';
import { base_url, tokenConfig } from './common';



export function get_ml_tasks(task_type, configuration_id, limit = 6) {
    return axios.get(base_url + 'ml/get_ml_tasks?task_type=' + task_type + '&configuration_id=' + configuration_id + '&limit=' + limit.toString(), tokenConfig());
}

export function get_ml_result_by_task(task_id) {
    return axios.get(base_url + 'ml/get_ml_result_by_task?task_id=' + task_id, tokenConfig());
}
export function check_if_task_is_done_nps(waitingId,parametersToGet) {
    return axios.get(base_url + `tasks/check_if_task_is_done?waiting_id=${waitingId}&task_type=CREATE_NPS_REPORT&parameters_to_get=${parametersToGet}`, tokenConfig());
}

export function get_latest_model_results_by_configuration_id(configuration_id) {
    return axios.get(base_url + 'analysis/get_latest_model_results_by_configuration_id?configuration_id=' + configuration_id, tokenConfig());
}



export function get_number_annotated(customer_configuration_id) {
    return axios.get(base_url + 'data/get_number_annotated?customer_configuration_id=' + customer_configuration_id, tokenConfig());
}
export const annotateSingleTopic = (requestObject) => axios.put(base_url + 'data/partial_annotate',
    { partial_annotations: requestObject.partialAnnotations, data_id: requestObject.dataId },
    tokenConfig());

export const removeAnnotateSingleTopic = (requestObject) => axios.put(base_url + 'data/remove_partial_annotate',
    { key_to_remove: requestObject.keyToRemove, data_id: requestObject.dataId },
    tokenConfig());






export function add_ml_task(configuration_id, ml_task_type, scan_every, data_start_date, data_end_date, is_one_time, product_id, flowId, app_type, app_id, filter_topics) {

    return axios.post(base_url + 'ml/add_ml_task',
        {
            'configuration_id': configuration_id,
            'ml_task_type': ml_task_type,
            'scan_every': scan_every,
            'data_start_date': data_start_date,
            'data_end_date': data_end_date,
            'is_one_time': is_one_time,
            'product_id': product_id,
            'flow_id': flowId,
            'app_type': app_type,
            'app_id': app_id,
            'filter_topics': filter_topics
        }, tokenConfig());
}

export function get_latest_insights(task_id) {
    return axios.get(base_url + 'ml/get_latest_insights?task_id=' + task_id, tokenConfig());
}

export function update_insight_text(task_id, data) {
    return axios.post(base_url + 'ml/update_insight_text?task_id=' + task_id, { 'data': data }, tokenConfig());
}

export function get_sentiment_prediction(data) {
    return axios.post(base_url + 'ml/get_sentiment_for_message', { 'txt': data }, tokenConfig());
}

export function get_customer_configurations(sortTopics, include_topics = 'true') {
    let url = base_url + 'customer/get_customer_configurations'
    url += '?include_topics=' + include_topics
    if (sortTopics != undefined) {
        url += '&sort_topics=' + sortTopics.toString()
    }

    return axios.get(url, tokenConfig());
}

export function get_all_topics_for_customer_configuration(customer_configuration_id, add_suggestions) {
    let params = '?customer_configuration_id=' + customer_configuration_id
    if (add_suggestions != undefined) {
        params = params + '&add_suggestions=' + add_suggestions.toString()
    }
    return axios.get(base_url + 'topic/get_all_topics_for_customer_configuration' + params, tokenConfig());
}

export function get_all_topics_configuration_with_keywords(customer_configuration_id) {
    return axios.get(base_url + 'topic/get_all_topics_configuration_with_keywords?customer_configuration_id=' + customer_configuration_id, tokenConfig());
}



export function get_messages_for_customer_configuration(customer_configuration_id) {
    return axios.get(base_url + 'data/get_messages_for_customer_configuration?customer_configuration_id=' + customer_configuration_id, tokenConfig());
}

export function get_topic_types() {

    return axios.get(base_url + 'topic/get_topic_types', tokenConfig());
}

export function get_topics_tree(customer_configuration_id) {
    return axios.get(base_url + 'topic/get_all_topics_for_customer_configuration_tree?&customer_configuration_id=' + customer_configuration_id, tokenConfig());
}

export function get_services_status_call() {

    return axios.get(base_url + 'ml/get_services_status', tokenConfig());
}

export function get_blacklist_terms(customer_configuration_id) {

    return axios.get(base_url + 'terms/get_blacklist_terms?customer_configuration_id=' + customer_configuration_id, tokenConfig());
}

export function delete_blacklist_term(term_id) {

    return axios.delete(base_url + 'terms/delete_blacklist_term?term_id=' + term_id, tokenConfig());
}
export function approve_blacklist_term(term_id) {

    return axios.put(base_url + 'terms/approve_blacklist_suggestion?term_id=' + term_id, {}, tokenConfig());
}



export function import_rules_from_generic_type(topic, topic_type_id) {
    return axios.post(base_url + 'topic/import_rules_from_generic_type', { 'topic': topic, 'topic_type_id': topic_type_id }, tokenConfig());
}


export function save_topics(task_id, topic_config) {
    return axios.post(base_url + 'topic/save_topics?customer_configuration_id=' + task_id, { 'topics': topic_config }, tokenConfig());
}

export function save_specific_topic(task_id, topic) {
    return axios.post(base_url + 'topic/save_specific_topic?customer_configuration_id=' + task_id, { 'topic': topic }, tokenConfig());
}

export function delete_topic(task_id, topic_id) {
    return axios.post(base_url + 'topic/delete_topic_tree', { 'topic_id': topic_id, customer_configuration_id: task_id }, tokenConfig());
}

export function save_topics_keywords_api(topics) {
    return axios.post(base_url + 'topic/save_topics_keywords', { 'topics': topics }, tokenConfig());
}


export function get_term_results(configuration_id, data_start_date, data_end_date) {
    return axios.post(base_url + 'terms/get_terms_for_configuration_date_range',
        {
            'configuration_id': configuration_id,
            'start_date': data_start_date,
            'end_date': data_end_date

        }, tokenConfig());
}


export function get_insights_for_configuration_date_range(configuration_id, data_start_date, data_end_date) {
    return axios.post(base_url + 'ml/get_insights_for_configuration_date_range',
        {
            'configuration_id': configuration_id,
            'start_date': data_start_date,
            'end_date': data_end_date

        }, tokenConfig());
}
















export function get_chart_data_for_topic_terms(configuration_id, topic1, sent1, topic2, sent2, terms, period, start_date, end_date) {
    let payload = {
        'configuration_id': configuration_id,
        'topic1': topic1,
        'sent1': sent1,
        'topic2': topic2,
        'sent2': sent2,
        'terms': terms,
        'period': period,
        'old_call': false

    }
    if (start_date != undefined) {
        payload['start_date'] = start_date
    }
    if (end_date != undefined) {
        payload['end_date'] = end_date
    }
    return axios.post(base_url + 'ml/get_chart_data_for_topic_terms', payload
        , tokenConfig());
}

export function get_terms_over_time(configuration_id, terms, period, start_date, end_date, sentiments, filter_topics) {
    let payload = {
        'configuration_id': configuration_id,

        'terms': terms,
        'period': period,
        'sentiments': sentiments,
        'filter_topics': filter_topics

    }
    if (start_date != undefined) {
        payload['start_date'] = start_date
    }
    if (end_date != undefined) {
        payload['end_date'] = end_date
    }
    return axios.post(base_url + 'insights/get_term_over_time', payload
        , tokenConfig());
}

export function get_topic_over_time(configuration_id, terms, period, start_date, end_date, sentiments, custom_term) {
    let payload = {
        'configuration_id': configuration_id,

        'term_list': terms,
        'period': period,
        'sentiments': sentiments

    }
    if (custom_term != undefined) {
        payload['filter_free_text'] = custom_term
    }

    if (start_date != undefined) {
        payload['start_date'] = start_date
    }
    if (end_date != undefined) {
        payload['end_date'] = end_date
    }
    return axios.post(base_url + 'insights/get_topic_over_time', payload
        , tokenConfig());
}

export function get_topic_stats(configuration_id, start_date, end_date) {
    let payload = {
        'configuration_id': configuration_id,
    }
    if (start_date != undefined) {
        payload['start_date'] = start_date
    }
    if (end_date != undefined) {
        payload['end_date'] = end_date
    }
    return axios.post(base_url + 'topic/get_topic_stats',
        payload, tokenConfig());
}






export function get_chart_data_for_terms_stats(configuration_id, topic1, sent1, topic2, sent2, start_date, end_date, trending_terms, trending_new_formula, combine_trending, use_model_for_terms, filter_terms) {
    let payload = {
        'configuration_id': configuration_id,
        'topic1': topic1,
        'sent1': sent1,
        'topic2': topic2,
        'sent2': sent2,
        'get_feedback': true,
        'trending_terms': trending_terms,
        'max_terms': 30,
        'old_call': false,
        'trending_new_formula': trending_new_formula,
        'combine_trending': combine_trending,
        'use_model_for_terms': use_model_for_terms



    }

    if (filter_terms != undefined && filter_terms != '') {
        payload['filter_terms'] = filter_terms.split(',')
    }

    if (start_date != undefined) {
        payload['start_date'] = start_date
    }

    if (end_date != undefined) {
        payload['end_date'] = end_date
    }
    return axios.post(base_url + 'terms/get_terms',
        payload
        , tokenConfig());
}

export function add_term_to_blacklist(term,
    configuration_id,
    topic_id,
    source_id,
    black_list_term_after_match,
    black_list_term_before_match,
    black_list_term_from_training_inference,
    is_regex
) {
    return axios.post(base_url + 'terms/add_term_to_blacklist',
        {
            'configuration_id': configuration_id,
            'term': term,
            'topic_id': topic_id,
            'source_id': source_id,
            'black_list_term_after_match': black_list_term_after_match,
            'black_list_term_before_match': black_list_term_before_match,
            'black_list_term_from_training_inference': black_list_term_from_training_inference,
            'is_regex': is_regex



        }, tokenConfig());
}

export function add_term_to_topic_keywords(term, topic_id) {
    return axios.post(base_url + 'terms/add_term_to_topic_keywords',
        {

            'term': term,
            'topic_id': topic_id



        }, tokenConfig());
}



export function create_insights_new(configuration_id, start_date, end_date, product_id) {
    return axios.post(base_url + 'ml/create_insights_new',
        {
            'configuration_id': configuration_id,
            'start_date': start_date,
            'end_date': end_date,
            'product_id': product_id,



        }, tokenConfig());
}



export function get_answer_to_question(question, configuration_id, start_date, end_date) {

    return axios.post(base_url + 'summary/ask_a_question',
        {
            'question': question,
            'configuration_id': configuration_id,
            'start_date': start_date,
            'end_date': end_date,



        }, tokenConfig());
}

export const restart_instance = (instance_id) => {
    return axios.post(base_url + 'ml/restart_instance', { instance_id }, tokenConfig());
}




